<template>
  <div>

    <b-alert variant="danger" v-if="Object.keys(errors).length > 0" show>
      {{ errors }}
    </b-alert>

    <b-container></b-container>
    <section id="hero">
      <b-container class="search-inputs-wrapper">
        <b-row>
          <b-col cols="12" md="8" lg="6">
            <h1 v-html="$t('testers.intro')"></h1>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <b-container>

      <section id="benefits">
        <b-row>
          <b-col cols="12" sm="6" class="mt-5">
            <i class="material-icons">
              important_devices
            </i>
            <h2 v-html="$t('testers.invitationTitle')" class="mt-0"></h2>
            <div v-html="$t('testers.invitation')"></div>
          </b-col>
          <b-col cols="12" sm="6" class="mt-5">
            <i class="material-icons">
              emoji_events
            </i>
            <h2 v-html="$t('testers.rewardTitle')" class="mt-0"></h2>
            <div v-html="$t('testers.reward')"></div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" sm="6" class="mt-5">
            <i class="material-icons">
              insert_emoticon
            </i>
            <h2 v-html="$t('testers.signUpTitle')" class="mt-0"></h2>
            <div v-html="$t('testers.signUp')"></div>
            <div class="text-center">
              <b-btn class="sign-up" variant="primary" v-b-modal.signUpModal>{{ $t('buttons.signUp') }}</b-btn>
            </div>
          </b-col>
          <b-col cols="12" sm="6" class="mt-5">
            <i class="material-icons">
              message
            </i>
            <h2 v-html="$t('testers.feedbackTitle')" class="mt-0"></h2>
            <div v-html="$t('testers.feedback')"></div>
          </b-col>
        </b-row>

        <h2 v-html="$t('testers.welcome')" class="welcome mt-5 mb-0"></h2>
      </section>

    </b-container>

    <section id="communication" class="mt-5">
      <b-container>
        <div class="text">
          <h3>{{ $t('testers.contactsTitle') }}</h3>
          <p>{{ $t('footer.email') }}: <a href="mailto:peteris@kelle.ventures">peteris@kelle.ventures</a><br />
          {{ $t('footer.phone') }}: +371 261 260 86</p>
        </div>
      </b-container>
    </section>

  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

  export default {
    name: 'ProfessionalsLanding',
    components: {
    },
    data () {
      return {
        errors: {}
      }
    },
    mounted () {
      // this.$el.addEventListener('click', this.onClose)
    }
  }
</script>

<style lang="scss" scoped>


  #hero {
    position: relative;
    min-height: 500px;
    background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/header_placeholder.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: visible;

    .search-inputs-wrapper {
      position: absolute;
      top: 70%;
      left: 50%;
      transform: translate(-50%, -70%);
      width: 100%;
      z-index: 10;
    }

    h1 {
      display: block;
      padding: 1rem;
      box-sizing: border-box;
      color: white;
      font-size: 2rem;
      font-weight: bold;
      text-align: left;
      background: rgba(0,0,0,0.5);
    }
  }

  section#benefits {
    i {
      color: #f1a444;
      font-size: 3rem;
    }
  }

  h2.welcome {
    span {
      color: #f1a444;
    }
  }

  #communication {
    position: relative;
    min-height: 500px;
    background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/footer_landing_professionals.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: visible;

    .container {
      position: relative;
      min-height: 500px;

      .text {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 50%;
        z-index: 10;

        h3 {
          display: block;
          padding: 1rem;
          box-sizing: border-box;
          color: white;
          font-size: 2rem;
          font-weight: bold;
          text-align: left;
          background: rgba(0,0,0,0.5);
        }

        p {
          display: block;
          padding: 1.2rem;
          box-sizing: border-box;
          color: white;
          font-size: 1rem;
          font-weight: bold;
          text-align: left;
          background: rgba(0,0,0,0.5);
        }

        @include media-breakpoint-down(md) {
          width: 100%;
        }
      }
    }
  }

  section {
    padding: 1rem 0;
  }
</style>

<style lang="scss" scoped>


  h2 {

  }
</style>
